import React from 'react';

const LogoSmall = () => {
  return (
    <svg
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="25"
      height="32"
      viewBox="0 0 25 32"
    >
      <defs>
        <polygon
          id="small-logo-a"
          points=".017 .645 18.837 .645 18.837 18.025 .017 18.025"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <polygon
          fill="#E6E414"
          points="15.608 22.978 14.122 24.472 13.264 23.611 14.753 22.12"
        />
        <polygon
          fill="#E6E414"
          points="15.728 30.843 15.728 31.029 15.728 30.936"
        />
        <polygon
          fill="#F6921E"
          points="15.727 30.936 15.728 30.843 15.728 31.026"
        />
        <g transform="translate(0 .08)">
          <mask id="small-logo-b" fill="#fff">
            <use xlinkHref="#small-logo-a" />
          </mask>
          <polygon
            fill="#E6E414"
            points="8.328 18.025 8.328 12.695 .017 12.695 12.026 .645 18.837 7.48"
            mask="url(#small-logo-b)"
          />
        </g>
        <polygon
          fill="#8BA728"
          points="24.035 12.775 15.728 12.775 15.728 18.496 11.14 18.496 14.753 22.12 13.264 23.611 8.328 18.662 8.328 18.105 18.837 7.56"
        />
        <polygon
          fill="#93B7C8"
          points="24.049 12.789 18.362 18.496 15.728 18.496 15.728 12.775 24.035 12.775"
        />
        <polygon
          fill="#F6921E"
          points="8.052 18.381 5.588 20.854 2.768 18.029 0 15.248 0 12.792 .014 12.778 8 12.778 5.232 15.556"
        />
        <polygon fill="#9B6D22" points="2.768 18.029 0 20.802 0 15.248" />
        <polygon
          fill="#93B7C8"
          points="8.328 23.604 8.328 30.286 7.163 31.455 0 31.455 0 20.802 2.768 18.029 5.587 20.854"
        />
        <polygon
          fill="#9B6D22"
          points="8.328 18.662 8.328 23.604 5.587 20.854 8.052 18.381"
        />
        <polygon
          fill="#E6E414"
          points="8.328 18.105 8.328 18.662 8.052 18.381"
        />
        <polygon
          fill="#866624"
          points="13.264 23.611 10.799 26.084 8.328 23.604 8.328 18.661"
        />
        <polygon
          fill="#8C4A24"
          points="15.728 18.496 15.728 21.138 14.753 22.12 11.14 18.496"
        />
        <polygon
          fill="#9A4C21"
          points="18.362 18.496 15.728 21.138 15.728 18.496"
        />
        <polygon
          fill="#D76229"
          points="15.728 21.138 15.728 26.084 14.122 24.472 15.608 22.978 14.753 22.12"
        />
        <polygon
          fill="#F16522"
          points="24.053 18.496 24.053 31.455 19.678 26.972 18.192 28.463 15.728 26.084 15.728 21.138 18.362 18.496"
        />
        <polygon
          fill="#F6921E"
          points="14.122 24.472 11.657 26.945 10.799 26.084 13.264 23.611"
        />
        <polygon
          fill="#D64629"
          points="15.728 26.084 15.728 30.843 15.728 30.936 11.658 26.945 14.122 24.472"
        />
        <polygon
          fill="#EE4623"
          points="18.192 28.463 15.727 30.936 15.728 26.084"
        />
        <polygon
          fill="#F6921E"
          points="21.085 31.455 16.26 31.455 15.727 30.936 18.192 28.463"
        />
        <polygon
          fill="#9A4C21"
          points="11.658 26.945 7.163 31.455 15.211 31.455 15.728 30.936"
        />
        <polygon
          fill="#8BA728"
          points="11.658 26.945 8.328 30.286 8.328 23.604"
        />
        <polygon
          fill="#93B7C8"
          points="15.727 30.936 15.21 31.455 16.26 31.455"
        />
      </g>
    </svg>
  );
};

export default LogoSmall;
